import { useState, useEffect } from "react";
import {
  getEmotionSummaryService,
  getEmotionSummaryFiltersService,
} from "../../services/api-service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Drawer from "@mui/material/Drawer";
import styles from "./index.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";
import { Switch } from "@mui/material";
import SummaryDetails from "../summary-details";
import HomeSummaryCard from "../home-page-summary-card";
import VideoPage from "../video_page";
import { MdFileDownload } from "react-icons/md";
import axios from "axios";

const filterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    ariaHidden="true"
  >
    <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"></path>
  </svg>
);
let todayDate = new Date();
let month = todayDate.getMonth() + 1;
if (month < 10) {
  month = "0" + month;
}
let year = todayDate.getFullYear();
let current_date = todayDate.getDate();
if (current_date < 10) {
  current_date = "0" + current_date;
}
todayDate = `${year}-${month}-${current_date}`;

const defaultFilters = {
  end_date: todayDate,
  start_date: todayDate,
  course_name: ["all"],
  locations: ["0"],
  session_id: [0],
  start_time: "00:00",
  end_time: "23:59",
};
function formatSelectData(data) {
  return { label: data, value: data };
}
export default function EmotionSummary() {
  const [data, setData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [locations, setLocations] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [filter, setFilter] = useState(defaultFilters);
  const [showDetails, setShowDetails] = useState(false);
  const [detailsId, setDetailsId] = useState();
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("table");
  const [showVideo, setShowVideo] = useState(false);
  const [videoNames, setVideoNames] = useState([]);
  const [videoId, setVideoId] = useState();
  const token = localStorage.getItem("accessToken");

  const handleOpenDrawer = () => {
    setOpen(true);
  };

  const handleCloseDrawer = () => {
    setOpen(false);
  };
  useEffect(() => {
    getEmotionSummaryFiltersService()
      .then((res) => {
        let formatCourseData = res?.data?.course_name?.map(formatSelectData);
        let formatLocationData = res?.data?.location?.map(formatSelectData);
        let formatSession = res?.data?.session_id?.map(formatSelectData);
        setLocations([...formatLocationData, { label: "all", value: "0" }]);
        setCourses([...formatCourseData, { label: "all", value: "all" }]);
        setSessions([...formatSession, { label: "all", value: 0 }]);
      })
      .catch((error) => {
        console.log("Failed to get emotion summary", error);
        toast.error("Error : Failed to  get filters !!!");
      });
  }, []);
  useEffect(() => {
    handleFilter();
  }, []);
  const handleChange = (event, name) => {
    setFilter({
      ...filter,
      [name]:
        event.length >= 0 ? event?.map((el) => el.value) : event.target.value,
    });
  };
  const handleFilter = () => {
    getEmotionSummaryService(filter)
      .then((response) => {
        setData(response?.data);
      })
      .catch((error) => {
        toast.error("Error : Failed to emotion summary !!!");
      });
  };
  const openVideoInNewTab = () => {
    const videoUrl =
      "http://127.0.0.1:8000/reports/get_video/${videoFilename}?video_filename=${videoFilename}";
    window.open(videoUrl, "_blank");
  };
  const handleShowVideo = (id, video_names) => {
    setVideoNames(video_names);
    setVideoId(id);
    setShowVideo(true);
  };

  const handleDownloadData = async () => {
    try {
      const response = await axios.post(
        "http://localhost:8000/reports/download_summary_excel",
        filter,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      // Extract file extension from content-disposition header
      const contentDisposition = response.headers["content-disposition"];
      const match =
        contentDisposition &&
        contentDisposition.match(/filename="?(.+?\.(\w+))"?$/);
      const filename = "summaries.xlsx";

      // Create a download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;

      // Append the link to the document
      document.body.appendChild(a);

      // Trigger the download
      a.click();

      // Remove the link from the document
      document.body.removeChild(a);
    } catch (error) {
      console.error(error);
      toast.error("Error in downloading file");
    }
  };

  return (
    <>
      {showDetails ? (
        <SummaryDetails id={detailsId} setShowDetails={setShowDetails} />
      ) : showVideo ? (
        <VideoPage
          videoNames={videoNames}
          id={videoId}
          setShowVideo={setShowVideo}
        />
      ) : (
        <main className={styles.emotionContainer}>
          <div>
            <button onClick={handleDownloadData} className={styles.download}>
              Download data <MdFileDownload style={{ fontSize: "1.5rem" }} />
            </button>
            <div>
              <label
                className={view === "table" ? styles.enable : styles.disable}
              >
                Table View
              </label>
              <Switch
                onChange={(event) =>
                  setView(event.target.checked ? "grid" : "table")
                }
              />
              <label
                className={view !== "table" ? styles.enable : styles.disable}
              >
                Grid View
              </label>
            </div>
            <button
              className={styles.drawerOpenButton}
              onClick={handleOpenDrawer}
            >
              {filterIcon}
            </button>
          </div>
          <Drawer anchor={"right"} open={open} onClose={handleCloseDrawer}>
            <div className={styles.filterContainer}>
              <CloseIcon
                className={styles.closeBtn}
                fontSize="large"
                onClick={handleCloseDrawer}
              />
              <div className={styles.head}>
                {" "}
                <div>Filter By</div>
                <p>You can use following filters</p>
              </div>
              <div className={styles.filterBox}>
                <div>
                  <label>Course</label>
                  <Select
                    required={true}
                    value={filter.course_name.map((el) => {
                      return { label: el, value: el };
                    })}
                    options={courses}
                    onChange={(event) => handleChange(event, "course_name")}
                    style={{
                      width: "100%",
                    }}
                    isMulti
                    placeholder={"Select Course"}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "rgb(51 65 85 / 63%)",
                        primary: "rgb(51 65 85)",
                      },
                    })}
                  />
                </div>
                <div>
                  <label>Location</label>
                  <Select
                    onChange={(event) => handleChange(event, "location")}
                    required={true}
                    value={filter.locations.map((el) => {
                      return { label: el === 0 ? "all" : el, value: el };
                    })}
                    options={locations}
                    style={{
                      width: "100%",
                    }}
                    isMulti
                    placeholder={"Select Location"}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "rgb(51 65 85 / 63%)",
                        primary: "rgb(51 65 85)",
                      },
                    })}
                  />
                </div>
                <div>
                  <label>Session Id</label>
                  <Select
                    onChange={(event) => handleChange(event, "session_id")}
                    required={true}
                    value={filter.session_id.map((el) => {
                      return { label: el === 0 ? "all" : el, value: el };
                    })}
                    options={sessions}
                    style={{
                      width: "100%",
                    }}
                    isMulti
                    placeholder={"Select Session Id"}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: "rgb(51 65 85 / 63%)",
                        primary: "rgb(51 65 85)",
                      },
                    })}
                  />
                </div>
                <div>
                  <label>Start Date</label>
                  <input
                    type="date"
                    value={filter.start_date}
                    onChange={(event) => handleChange(event, event.target.name)}
                    name="start_date"
                  />
                </div>
                <div>
                  <label>End Date</label>
                  <input
                    type="date"
                    value={filter.end_date}
                    onChange={(event) => handleChange(event, event.target.name)}
                    name="end_date"
                  />
                </div>
                <div>
                  <label>Start Time</label>
                  <input
                    type="time"
                    name={"start_time"}
                    value={filter.start_time}
                    onChange={(event) => handleChange(event, event.target.name)}
                  />
                </div>
                <div>
                  <label>End Time</label>
                  <input
                    type="time"
                    name={"end_time"}
                    value={filter.end_time}
                    onChange={(event) => handleChange(event, event.target.name)}
                  />
                </div>
              </div>
              <button onClick={handleFilter}>Filter Data</button>
            </div>
          </Drawer>

          {view !== "table" ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                padding: "5px",
                gap: "1rem",
                width: "100%",
              }}
            >
              {data?.map((el) => (
                <HomeSummaryCard
                  setShowDetails={setShowDetails}
                  handleShowVideo={handleShowVideo}
                  setDetailsId={setDetailsId}
                  data={el}
                />
              ))}
            </div>
          ) : (
            <div className={styles.tableContainer}>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Start time</th>
                    <th>End time</th>
                    <th>Location</th>
                    <th>Course Name</th>
                    <th>Total</th>
                    <th>Present</th>
                    <th>Absent</th>
                    <th>Anger</th>
                    <th>Disgust</th>
                    <th>Fear</th>
                    <th>Happy</th>
                    <th>Neutral</th>
                    <th>Sadness</th>
                    <th>Suprise</th>
                    <th>contempt</th>
                    <th>Details</th>
                    <th>Video</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((d) => {
                    return (
                      <tr key={d.course_id}>
                        <td className="es-th">{d.date}</td>
                        <td className="es-th">{d.start_time}</td>
                        <td className="es-th">{d.end_time}</td>
                        <td className="es-th">{d.location}</td>
                        <td
                          className="es-th"
                          style={{ textTransform: "capitalize" }}
                        >
                          {d.course_name}
                        </td>
                        <td className="es-th">{d.total}</td>
                        <td className="es-th">{d.present}</td>
                        <td className="es-th">{d.absent}</td>
                        <td className="es-th">{d.anger}%</td>
                        <td className="es-th">{d.disgust}%</td>
                        <td className="es-th">{d.fear}%</td>
                        <td className="es-th">{d.happy}%</td>
                        <td className="es-th">{d.neutral}%</td>
                        <td className="es-th">{d.sad}%</td>
                        <td className="es-th">{d.surprise}%</td>
                        <td className="es-th">{d.contempt}%</td>
                        <td className="es-th">
                          <p
                            className={styles.detailsBtn}
                            style={{ fontWeight: "500" }}
                            onClick={() => {
                              setShowDetails(true);
                              setDetailsId(d.id);
                            }}
                          >
                            Details
                          </p>
                        </td>
                        <td className="es-th">
                          <p
                            className={styles.detailsBtn}
                            style={{ fontWeight: "500" }}
                            onClick={() => handleShowVideo(d.id, d.video_names)}
                          >
                            Video
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </main>
      )}
    </>
  );
}
